import React, { ReactNode } from 'react';
import { IWprModeProps } from '../props/IWprModeProps';
import { WprBaseModeComponent } from './WprBaseModeComponent';
import { WprBaseControlComponent } from './WprBaseControlComponent';
import { IWprControlProps } from '../props/IWprControlProps';
import { WprControlVisibility } from '../props/IWprControlState';

/**
 * DIVプロパティ情報
 */
interface IWprDivProps extends IWprControlProps {
}

/**
 * DIVコントロール
 */
export class WprDiv extends WprBaseControlComponent<IWprDivProps, HTMLDivElement> {
	// プロパティ  ---------------------------------------------------------------
	/** 編集フラグ */
	public get isEdit(): boolean	{ return false; 	}
	// --------------------------------------------------------------------------

	// コンストラクタ  -----------------------------------------------------------
	constructor(props: IWprDivProps){
		super(props);
	}
	// --------------------------------------------------------------------------

	// override メソッド  --------------------------------------------------------
	/**
	 * 値取得
	 * @returns 値
	 */
	protected getValue(): any {
		return undefined;
	}

	/**
	 * 描画
	 */
	public onRender(): ReactNode {
		if (this.state.visibility === WprControlVisibility.COLLAPSED)
			return <></>;
		const props = this.getProps();
		const {name, view, className, children, ...other} = this.props;
		const state = this.getState(['style', 'disabled']);
		let div = null;
		if (this.state.visibility === WprControlVisibility.VISIBLE) {
			div = <div {...props} {...state} {...other}>{this.props.children}</div>;
		}
		else {
			div = <div hidden {...props} {...state} {...other}>{this.props.children}</div>;
		}
		return (
			<>
				{div}
			</>
		);
	}
	// --------------------------------------------------------------------------
}